export default __webpack_public_path__ + "42aad91bf10d526d59490b6c23665cbe.png";